import * as React from 'react';
import { NewbuildingBrokerOnboarding } from 'shared/components/NewbuildingBrokerOnboarding';

import { useNewbuildingBrokerOnboarding } from './hooks/useNewbuildingBrokerOnboarding';

export const NewbuildingBrokerOnboardingContainer = () => {
  const { open, closeOnboarding } = useNewbuildingBrokerOnboarding();

  if (!open) {
    return null;
  }

  return <NewbuildingBrokerOnboarding onClose={closeOnboarding} />;
};
